<template>
	<div :class="parent">
		<div style="display:inline-block">
	        <div class="search-field" style="float:left">
	            <button v-on:click="clear()" style="height:30px; width:40px;"><font-awesome-icon icon="times" /></button>
	    		<input v-model="search_term" @keydown.enter="setRouter(true)" @input="setRouter(false)"></input>
	            <button v-on:click="setRouter(true)" style="height:30px; width:40px;"><font-awesome-icon icon="search" /></button>
				<b v-if="use_limit==true">Limit</b>
				<input v-if="use_limit==true" v-model="limit" @keydown.enter="setRouter(true)" style="width:60px"></input>
	        </div>
		</div>

		<div class="scroll" style="height:calc(100vh - 310px);">
			<table>
				<thead v-if="column_names.length>0">
					<tr>
						<th
						v-bind:colspan="column_names.length+1"
						class="table-header">
							{{table_name}} Table <button class="copy-table" v-on:click="copyTable()">Copy Table</button>
						</th>
					</tr>

					<tr>
						<th style="width:30px"></th>

						<th v-for="(name, index) in column_names" v-if="name!='Selected'">
							<div style="display:inline-block; white-space:nowrap;">
								{{name}}
								<button v-if="sort_value[index]==0" v-on:click="sort(index)"><font-awesome-icon icon="sort" /></button>
								<button v-else-if="sort_value[index]==1" v-on:click="sort(index)"><font-awesome-icon icon="sort-up" /></button>
								<button v-else-if="sort_value[index]==2" v-on:click="sort(index)"><font-awesome-icon icon="sort-down" /></button>
							</div>
						</th>
					</tr>
				</thead>
				<thead v-else-if="loading==true"><tr><th class="table-header">{{table_name}} Table Loading...</th></tr></thead>
                <thead v-else><tr><th class="table-header">{{table_name}} Table Empty</th></tr></thead>
				<tbody v-if="column_names.length>0">
					<tr v-for="(column, col) in column_data">

						<td style="width:30px"><input type="checkbox" v-on:change="insert(column_data[col][1], column_data[col][0])" v-model="column_data[col][0]" style="width:30px"></input></td>

						<td v-for="(data, index) in column" v-if="index!=0" v-bind:id="'tableRow-'+col">
							<div v-if="column_names[index] == 'Side' && data!='null'" v-bind:id="'side-'+col">
								{{data}}
							</div>
							<div v-else>
								{{data}}
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: '',
        id: Number,
		table_name:{
			type:String,
			required:false,
			default:""
		},
    },
	data() {
		return {
			perms:[],
			search_term:'',
			limit:200,
			column_names: [],
			column_data:[],
			sort_value:[],
			loading:true,
            lastUpdate: 0,
		}
	},
	async created () {
		this.perms = api.getPerms();
		var getLimit = api.getCookie("limit_"+this.id)
		if(getLimit!=null && getLimit!=undefined) { this.limit = getLimit }

		this.search(true)
	},
	methods: {
		async sort(index){
			this.sort_value.splice(index, 1, this.sort_value[index]+1);
			if(this.sort_value[index]>2)
				this.sort_value.splice(index, 1, 0);
			this.search(true)
		},
        async clear (){
            this.search_term = "";
            this.setRouter(true);
        },
		async setRouter(full){
			this.search(full);
		},
		insert(joborder, value){
			return(api.postData(
				{
					type:"insert",
					data:{
						pageid:this.id,
						limit:this.limit,
						data:[
							this.term,
							joborder,
							value,
						],
					}
				}
			))
		},
		async search (full){
			var currentTerm = this.search_term;

			document.cookie="limit_"+this.id+"="+this.limit+";";
			this.loading=true;
			let timestamp = new Date().getTime()

			api.postData(
                {
                    type:"search",
                    data:{
						pageid:this.id,
						fullsearch:full,
						limit:this.limit,
						data:[
							this.search_term,
							this.term,
	                    ],
						sort:this.sort_value,
					},
					timestamp:timestamp,
                }
            ).then((res) => {
				if(res.data.timestamp > this.lastUpdate){
					this.lastUpdate = res.data.timestamp
					this.clearColors()

					if(res.data.data!=null && res.data.data.column_data!=null){
			            this.column_names = res.data.data.column_names;
						this.column_data = res.data.data.column_data;

						for(var i = 0;i<this.column_data.length;i++){
							if(this.column_data[i][0]=='true'){
								this.column_data[i][0]=true;
							}else{
								this.column_data[i][0]=false;
							}
						}

						if(this.sort_value.length==0){
							for(let i = 0;i<res.data.data.column_names.length;i++) {
								this.sort_value[i] = 0;
							}
						}
					}

					if(full){
						api.setWOColors()
					}
					this.setColors()
				}
	        }).finally((res)=>{
				this.loading=false;
			});
		},
		async clearColors(){
			if(this.column_names.includes('Side')){
				let position = this.column_names.indexOf('Side')
				for(let i = 0; i<this.column_data.length;i++){

					var element = document.getElementById('side-'+i).parentElement
					element.removeAttribute('style');
				}
			}

			if(this.column_names.includes('Color')){
				let position = this.column_names.indexOf('Color')
				for(let i = 0; i<this.column_data.length;i++){

					var row = document.getElementById('tableRow-'+i)
					row.removeAttribute('style');
				}
			}
		},
		async setColors(){
			let stateCheck = setInterval(() => {
				if (document.getElementById("tableRow-0")!=null) {
					clearInterval(stateCheck);

					if(this.column_names.includes('Side')){
						let position = this.column_names.indexOf('Side')
						for(let i = 0; i<this.column_data.length;i++){
							if(this.column_data[i][position]=="Port"){

								var element = document.getElementById('side-'+i).parentElement
								var style = 'background-color:#ffb5b5;';
								element.setAttribute('style', style);
							}
							else if(this.column_data[i][position]=="Starboard"){

								var element = document.getElementById('side-'+i).parentElement
								var style = 'background-color:#a5ffa5;';
								element.setAttribute('style', style);
							}
						}
					}

					if(this.column_names.includes('Color')){
						let position = this.column_names.indexOf('Color')
						for(let i = 0; i<this.column_data.length;i++){
							if(this.column_data[i][position]!=null){

								var color = this.column_data[i][position]
								var row = document.getElementById('tableRow-'+i)
								var style = 'background-color: #'+color+';';
								row.setAttribute('style', style);
							}
						}
					}
				}
			}, 100);
		},
		async copyTable(){
			var copyText = ''

			for(let i = 0;i < this.column_names.length;i++){
				copyText += this.column_names[i] + '\t'
			}
			copyText+='\n'

			for(let i = 0;i < this.column_data.length;i++){
				for(let j = 0; j< this.column_data[i].length;j++){
					copyText += this.column_data[i][j] + '\t'
				}
				copyText+='\n'
			}

			var el = document.createElement('textarea');
		    el.value = copyText;
		    document.body.appendChild(el);
		    el.select();
			el.setSelectionRange(0, 99999);
		    document.execCommand('copy');
		    document.body.removeChild(el);
			alert("copied to clipboard")
		},
	},
	watch:{
		term(){
			this.search(true);
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/layouts/layout_11.vue